import { sessaoFetchLoading } from '@/service/fetch'

export async function get () {
  return sessaoFetchLoading('consig', '/unidade_pacotes/saldopacotesunidade', 'GET')
}



// WEBPACK FOOTER //
// ./src/api/saldos.js